import { useTypesStore } from "../store/Types.js";
import { useTypesRender } from "../utils/useRender.js";
export var Null = props => {
  var {
    Null: Comp = {}
  } = useTypesStore();
  useTypesRender(Comp, props, 'Null');
  return null;
};
Null.displayName = 'JVR.Null';